import { render } from "./shareTrip.vue?vue&type=template&id=2cf39ac2&scoped=true"
import script from "./shareTrip.vue?vue&type=script&lang=js"
export * from "./shareTrip.vue?vue&type=script&lang=js"

import "./shareTrip.vue?vue&type=style&index=0&id=2cf39ac2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf39ac2"]])

export default __exports__